import gql from 'graphql-tag';

export const REVERT_AUDITLOG_ENTRIES = gql`
  mutation revertAuditLogEntries($ids: [Int]) {
    revertAuditLogEntries(ids: $ids)
  }
`;
